import { PLAY_MODE, PRELOAD_TYPE } from '../enums';
export var defaultPlayerConfig = {
    /** 是点播模式还是直播模式 */
    type: PLAY_MODE.VOD,
    /**
     * 如果是打断式切换，在视频播放接近结束时，是不需要马上跳转的。例如离播放结束只有1s了，那么打断式切换就没必要了。
     * <br>【注】：仅点播播放时候有效
     */
    interruptPlayNextMinTime: 1,
    /**
     * 对备份的地址列表的最大重试值，轮询备用地址列表时，不管列表备用地址数目有多少，只需要此最大值
     */
    backupUrlsMaxRetryCount: 5,
    /** 预加载的最大超时时间 */
    maxPreloadTimeout: 30000,
    /**
     * @deprecated
     */
    maxBufferingTimeout: 30000,
    /** 某些状态可停留的最大时间，例如缓冲状态。单位毫秒 */
    maxStateStalledTime: 30000,
    /** 在playing状态下，playtime最大停滞时间 */
    maxPlaytimeStalledTime: 10000,
    /**
     * 是否是列表播放
     * <br>注意：
     * <br>播放器的列表播放分两种场景：
     * <br>1. play接口传入UrlConfig数组的列表播放，播放以后无法干涉任何拼接播放逻辑
     * <br>2. 依赖preloadNext、appendNext接口的灵活的列表播放场景。此时需要传入此参数，播放器则永远在已播放状态（played为true），要想结束
     * 播放，需要手动调用stop接口
     */
    isPlayList: false,
    preloadType: PRELOAD_TYPE.AUTO_LOAD,
    /**
     * 默认创建的最大VideoNode数量。此值会影响到可以同时预加载的视频数，例如如果需要同时预加载3个视频，这个值就需要指定为3+1
     */
    maxVideoNodeCount: 1,
    /**
     * video渲染的视频画面和播放器高宽比不匹配时候，允许的黑边最小值。如果小于等于最小值，播放器会强制将视频画面会填充黑边。
     * 注意：如果传入值小于等于0，则播放器不会填充。
     */
    minFillBlackBorder: 10,
    minFragmentCountForSmoothLevelSwitching: 3,
    ignoreEndedWhenLive: true,
    /** 上报采样率，例如配置core引用上报的采样率 */
    rptRate: 0.2,
};
